import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { DynamicControl } from "../../dynamic-forms/dynamic-control.model";
import { DynamicArray } from "../../dynamic-forms/form-arrays/dynamic-array.model";
import { FixedArray } from "../../dynamic-forms/form-arrays/fixed-array/fixed-array.model";
import { SaveArray } from "../../dynamic-forms/form-arrays/save-array/save-array.model";
import { AbaHeightGroup } from "../../dynamic-forms/form-groups/aba-height-group/aba-height-group.model";
import { BmiGroup } from "../../dynamic-forms/form-groups/bmi-group/bmi-group.model";
import { DischargeGroup } from "../../dynamic-forms/form-groups/discharge-group/discharge-group.model";
import { DynamicGroup } from "../../dynamic-forms/form-groups/dynamic-group.model";
import { NegativeReasonCodeGroup } from "../../dynamic-forms/form-groups/negative-reason-code-group/negative-reason-code-group.model";
import { DeliveryGroup } from "../../dynamic-forms/form-groups/ppc/delivery-group/delivery-group.model";
import { DodDeliveryGroup } from "../../dynamic-forms/form-groups/ppc/dod-delivery-group/dod-delivery-group.model";
import { EarlyLateIndicatorGroup } from "../../dynamic-forms/form-groups/ppc/early-late-indicator-group/early-late-indicator-group.model";
import { EddPrenatalGroup } from "../../dynamic-forms/form-groups/ppc/edd-prenatal-group/edd-prenatal-group.model";
import { PrenatalGroup } from "../../dynamic-forms/form-groups/ppc/prenatal-group/prenatal-group.model";
import { SaveGroup } from "../../dynamic-forms/form-groups/save-group/save-group.model";
import { StandardGroup } from "../../dynamic-forms/form-groups/standard-group/standard-group.model";
import { FormService } from "../../dynamic-forms/form.service";
import { Autocomplete } from "../../dynamic-forms/inputs/autocomplete/autocomplete.model";
import { Calendar } from "../../dynamic-forms/inputs/calendar/calendar.model";
import { CheckboxGroup } from "../../dynamic-forms/inputs/checkbox-group/checkbox-group.model";
import { Checkbox } from "../../dynamic-forms/inputs/checkbox/checkbox.model";
import { ConfirmAutocomplete } from "../../dynamic-forms/inputs/confirm-autocomplete/confirm-autocomplete.model";
import { ConfirmNoPageNumber } from "../../dynamic-forms/inputs/confirm-no-page-number/confirm-no-page-number.model";
import { Confirm } from "../../dynamic-forms/inputs/confirm/confirm.model";
import { Dropdown } from "../../dynamic-forms/inputs/dropdown/dropdown.model";
import { DynamicInput } from "../../dynamic-forms/inputs/dynamic-input.model";
import { Multiselect } from "../../dynamic-forms/inputs/multiselect/multiselect.model";
import { Radiobutton } from "../../dynamic-forms/inputs/radiobutton/radiobutton.model";
import { SelectableInput } from "../../dynamic-forms/inputs/selectable-input.model";
import { Switch } from "../../dynamic-forms/inputs/switch/switch.model";
import { Resize } from "../../dynamic-forms/inputs/textarea/resize.enum";
import { Textarea } from "../../dynamic-forms/inputs/textarea/textarea.model";
import { TextBoxWithButton } from "../../dynamic-forms/inputs/textbox-with-button/textboxwithbutton.model";
import { TextboxType } from "../../dynamic-forms/inputs/textbox/textbox-type.enum";
import { Textbox } from "../../dynamic-forms/inputs/textbox/textbox.model";
import { VrcDropdown } from "../../dynamic-forms/inputs/vrc-dropdown/vrc-dropdown.model";

@Component({
  selector: "toolbox-forms",
  templateUrl: "./forms.component.html",
  styleUrls: ["./forms.component.scss"],
})
export class FormsComponent implements OnInit {
  updateForm: FormGroup;
  updateInputs: DynamicInput[];
  testForm: FormGroup;
  testInputs: DynamicInput[];
  abstractionTestForm: FormGroup;
  abstractionTestInputs: DynamicInput[];
  groupsTestForm: FormGroup;
  groupsTestInputs: DynamicControl[];


  constructor(
    private formService: FormService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.createTestForm();
    this.createUpdateForm();
    this.createAbstractionTestForm();
    this.createGroupTestForm();
  }

  toggleDisableOnTestInputs(disable: any): void {
    this.testInputs.forEach(a => a.disabled = disable.checked);
    this.testForm = this.formService.createFormGroup(this.testInputs);

    this.abstractionTestInputs.forEach(a => a.disabled = disable.checked);
    this.abstractionTestForm = this.formService.createFormGroup(this.abstractionTestInputs);

    this.groupsTestInputs.forEach(a => {
      if (a instanceof DynamicGroup) {
        a.controls.forEach(b => b.disabled = disable.checked);
      } else if (a instanceof DynamicArray) {
        a.models.forEach(b => {
          b.controls.forEach(c => c.disabled = disable.checked);
          b.disabled = disable.checked;
        });
      }

      a.disabled = disable.checked;
    });
    this.groupsTestForm = this.formService.createFormGroup(this.groupsTestInputs);

    this.cd.markForCheck();
  }

  toggleAdminOnTestInputs(isAdmin: any): void {
    this.testInputs.forEach(a => a.isAdmin = isAdmin.checked);
    this.testForm = this.formService.createFormGroup(this.testInputs);

    this.abstractionTestInputs.forEach(a => a.isAdmin = isAdmin.checked);
    this.abstractionTestForm = this.formService.createFormGroup(this.abstractionTestInputs);

    this.groupsTestInputs.forEach(a => {
      if (a instanceof DynamicGroup) {
        a.controls.forEach(b => b.isAdmin = isAdmin.checked);
      } else if (a instanceof DynamicArray) {
        a.models.forEach(b => {
          b.controls.forEach(c => c.isAdmin = isAdmin.checked);
          b.isAdmin = isAdmin.checked;
        });
      }

      a.isAdmin = isAdmin.checked;
    });
    this.groupsTestForm = this.formService.createFormGroup(this.groupsTestInputs);

    this.cd.markForCheck();
  }

  toggleChangeOnTestInputs(workflowStatus: string): void {
    this.testInputs.forEach(a => {
      a.workflowStatusName = workflowStatus;
      a.isChanged = workflowStatus !== "onchange";
    });
    this.testForm = this.formService.createFormGroup(this.testInputs);

    this.abstractionTestInputs.forEach(a => {
      a.workflowStatusName = workflowStatus;
      a.isChanged = workflowStatus !== "onchange";
    });
    this.abstractionTestForm = this.formService.createFormGroup(this.abstractionTestInputs);

    this.groupsTestInputs.forEach(a => {
      if (a instanceof DynamicGroup) {
        a.controls.forEach(b => {
          b.workflowStatusName = workflowStatus;
          b.isChanged = workflowStatus !== "onchange";
        });
      } else if (a instanceof DynamicArray) {
        a.models.forEach(b => {
          b.controls.forEach(c => {
            c.workflowStatusName = workflowStatus;
            c.isChanged = workflowStatus !== "onchange";
          });
          b.workflowStatusName = workflowStatus;
          b.isChanged = workflowStatus !== "onchange";
        });
      }

      a.workflowStatusName = workflowStatus;
      a.isChanged = workflowStatus !== "onchange";
    });
    this.groupsTestForm = this.formService.createFormGroup(this.groupsTestInputs);

    this.cd.markForCheck();
  }

  onChange(event, model) {


    if (typeof event.success === "function") {
      event.success();
      this.cd.markForCheck();
      this.formService.updateDom.next();
    }
  }

  onInput(event, model) {

  }

  submit() {

  }


  private createUpdateForm(): void {
    this.updateInputs = [
      new Checkbox({
        key: "disable",
        label: "Disable Inputs",
      }),
      new Checkbox({
        key: "isadmin",
        label: "Admin Inputs",
      }),
      new Radiobutton({
        key: "change",
        label: "Abstraction Change",
        name: "change",
        value: "nochange",
        options: [
          new SelectableInput({ text: "No Change", value: "nochange" }),
          new SelectableInput({ text: "Overread", value: "overread" }),
          new SelectableInput({ text: "Overread2", value: "overread2" }),
        ],
      }),
    ];

    this.updateForm = this.formService.createFormGroup(this.updateInputs);
  }

  private createTestForm(): void {
    const options = [
      new SelectableInput({ text: "foofoo", value: "12" }),
      new SelectableInput({ text: "boofoo", value: "23" }),
      new SelectableInput({ text: "loofoo", value: "34" }),
      new SelectableInput({ text: "toofoo", value: "45" }),
    ];

    this.testInputs = [
      new Textbox({
        key: "textbox",
        label: "Textbox",
        placeholder: "Textbox",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Textbox({
        key: "numbertextbox",
        type: TextboxType.NUMBER,
        label: "Number Textbox with Custom Styles",
        placeholder: "Number Textbox",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
        classOverride: "form__classOverride",
      }),
      new TextBoxWithButton({
        key: "textBoxWithButton",
        label: "TextBox With Button",
        placeholder: "TextBox With Button",
        labelWhenInputIsDisabled: "Label when input is disabled",
        // disabled: false,  // Not disabled, user can edit
        buttonText: "Button",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
        tooltip: "Tooltip for TextBox With Button",
      }),
      new Dropdown({
        key: "dropdown",
        label: "Dropdown",
        placeholder: "Select...",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Autocomplete({
        key: "autocomplete",
        label: "Autocomplete",
        placeholder: "Select...",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Multiselect({
        key: "multiselect",
        label: "Multiselect",
        placeholder: "Select...",
        options,
        maxSelectedLabels: 3,
      }),
      new Calendar({
        key: "calendar",
        label: "Calendar",
        placeholder: "MM/DD/YYYY",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Textarea({
        key: "textarea",
        label: "Textarea",
        placeholder: "Long form text...",
        rows: 4,
        resize: Resize.VERTICAL,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Switch({
        key: "switch",
        label: "Switch",
        preceedingOffLabel: "Preceeding Label",
        followingOnLabel: "Following Label",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Checkbox({
        key: "checkbox",
        label: "Checkbox",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new CheckboxGroup({
        key: "checkbox-group",
        label: "Checkbox Group",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new Radiobutton({
        key: "radiobutton",
        label: "Radio Button",
        name: "radiobuttons",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
    ];

    this.testForm = this.formService.createFormGroup(this.testInputs);
  }

  private createGroupTestForm(): void {
    const options = [
      new SelectableInput({ text: "foofoo", value: "12" }),
      new SelectableInput({ text: "boofoo", value: "23" }),
      new SelectableInput({ text: "loofoo", value: "34" }),
      new SelectableInput({ text: "toofoo", value: "45" }),
    ];

    const textboxStandardGroup = new StandardGroup({
      key: "textbox_standard_group",
      header: "Textbox Standard Group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
        new Textbox({
          key: "numbertextbox",
          type: TextboxType.NUMBER,
          label: "Number Textbox",
          placeholder: "Number Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const textboxSaveGroup = new SaveGroup({
      key: "textbox_save_group",
      header: "Textbox Save Group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
        new Textbox({
          key: "numbertextbox",
          type: TextboxType.NUMBER,
          label: "Number Textbox",
          placeholder: "Number Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const abaHeightGroup = new AbaHeightGroup({
      key: "aba_height_group",
      header: "ABA Height Group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
        new Textbox({
          key: "numbertextbox",
          type: TextboxType.NUMBER,
          label: "Number Textbox",
          placeholder: "Number Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const bmiGroup = new BmiGroup({
      key: "bmi_group",
      header: "BMI Group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
        new Textbox({
          key: "numbertextbox",
          type: TextboxType.NUMBER,
          label: "Number Textbox",
          placeholder: "Number Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const dischargeGroup = new DischargeGroup({
      key: "discharge_group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const deliveryGroup = new DeliveryGroup({
      key: "delivery_group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const dodDeliveryGroup = new DodDeliveryGroup({
      key: "dod_delivery_group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const earlyLateIndicatorGroup = new EarlyLateIndicatorGroup({
      key: "early_late_indicator_group",
    });

    const eddPrenatalGroup = new EddPrenatalGroup({
      key: "edd_prenatal_group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const prenatalGroup = new PrenatalGroup({
      key: "prenatal_group",
      controls: [
        new Textbox({
          key: "textbox",
          label: "Textbox",
          placeholder: "Textbox",
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const negativeReasonCodeGroup = new NegativeReasonCodeGroup({
      key: "negative_reason_code_group",
      header: "Negative Reason Code",
      controls: [
        new Autocomplete({
          key: "autocomplete",
          label: "Autocomplete",
          placeholder: "Select...",
          options,
          validators: Validators.required,
          errorMessages: { required: "Error message." },
        }),
      ],
    });

    const saveArray = new SaveArray({
      key: "textbox_save_array",
      header: "Save Array",
      models: [
        new StandardGroup({
          key: "textbox_standard_group",
          header: "Textbox Standard Group",
          controls: [
            new Textbox({
              key: "textbox",
              label: "Textbox",
              placeholder: "Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
            new Textbox({
              key: "numbertextbox",
              type: TextboxType.NUMBER,
              label: "Number Textbox",
              placeholder: "Number Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
          ],
        }),
      ],
    });
    saveArray.template = () => new StandardGroup(saveArray.models[0]);

    const fixedArray = new FixedArray({
      key: "textbox_fixed_array",
      header: "Fixed Array",
      models: [
        new StandardGroup({
          key: "textbox_standard_group",
          header: "Textbox Standard Group",
          controls: [
            new Textbox({
              key: "textbox",
              label: "Textbox",
              placeholder: "Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
            new Textbox({
              key: "numbertextbox",
              type: TextboxType.NUMBER,
              label: "Number Textbox",
              placeholder: "Number Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
          ],
        }),
        new StandardGroup({
          key: "textbox_standard_group",
          header: "Textbox Standard Group",
          controls: [
            new Textbox({
              key: "textbox",
              label: "Textbox",
              placeholder: "Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
            new Textbox({
              key: "numbertextbox",
              type: TextboxType.NUMBER,
              label: "Number Textbox",
              placeholder: "Number Textbox",
              validators: Validators.required,
              errorMessages: { required: "Error message." },
            }),
          ],
        }),
      ],
    });


    this.groupsTestInputs = [
      textboxStandardGroup,
      textboxSaveGroup,
      abaHeightGroup,
      bmiGroup,
      dischargeGroup,
      deliveryGroup,
      dodDeliveryGroup,
      earlyLateIndicatorGroup,
      eddPrenatalGroup,
      prenatalGroup,
      negativeReasonCodeGroup,
      saveArray,
      fixedArray,
    ];

    this.groupsTestForm = this.formService.createFormGroup(this.groupsTestInputs);
  }

  private createAbstractionTestForm(): void {
    const options = [
      new SelectableInput({ text: "foofoo", value: "12" }),
      new SelectableInput({ text: "boofoo", value: "23" }),
      new SelectableInput({ text: "loofoo", value: "34" }),
      new SelectableInput({ text: "toofoo", value: "45" }),
    ];

    this.abstractionTestInputs = [
      new Confirm({
        key: "confirmbutton",
        label: "Confirm Button",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new ConfirmAutocomplete({
        key: "confirm_autocomplete",
        label: "Confirm Autocomplete",
        placeholder: "Select...",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      new ConfirmNoPageNumber({
        key: "confirmNoPageNumberbutton",
        label: "Confirm No Page Number Button",
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
      // // NOTE: To test ConfirmProvider, uncomment and fix the injection bug in the component.ts.
      // new ConfirmProvider({
      //     key: "confirm_provider",
      //     label: "Confirm Provider",
      //     placeholder: "Select...",
      //     options,
      //     validators: Validators.required,
      //     errorMessages: { required: "Error message." },
      // }),
      // // NOTE: To test ProviderDropdown, uncomment and fix the injection bug in the component.ts.
      // new ProviderDropdown({
      //   key: "provider_dropdown",
      //   label: "Provider Dropdown",
      //   placeholder: "Select...",
      //   options,
      //   validators: Validators.required,
      //   errorMessages: { required: "Error message." },
      // }),
      new VrcDropdown({
        key: "vrc_dropdown",
        label: "VRC Dropdown",
        placeholder: "Select...",
        options,
        validators: Validators.required,
        errorMessages: { required: "Error message." },
      }),
    ];

    this.abstractionTestForm = this.formService.createFormGroup(this.abstractionTestInputs);
  }

  trackByIndex(index, item) {
    return index;
  }
}
